import { render, staticRenderFns } from "./program.vue?vue&type=template&id=aa7dc92a&"
import script from "./program.vue?vue&type=script&lang=ts&"
export * from "./program.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports